// Who can use each article action, by Evolok metering segment (ADR-013).
// listen must match what serve_audio() grants server-side.
export const ENTITLEMENTS = {
  save: ['Subscriber', 'Domain-based Access'],
  pdf: ['Subscriber', 'Domain-based Access', 'IP-based Access'],
  listen: ['Subscriber', 'Domain-based Access', 'IP-based Access'],
}

// Account segments count only with a session: Evolok keeps them on a known
// visitor after logout, alongside 'Logged-Out'.
const ACCOUNT_SEGMENTS = ['Subscriber', 'Domain-based Access']

// Gift eligibility is a purchase fact, not a segment: authorize reports it as
// articleSharingEnabled, which also survives logout.
export function canGift({ articleSharingEnabled, loggedOut = true } = {}) {
  return !loggedOut && articleSharingEnabled === true
}

export function can(action, { segments, loggedOut = true } = {}) {
  return (ENTITLEMENTS[action] ?? []).some(
    (segment) =>
      segments?.includes(segment) &&
      !(loggedOut && ACCOUNT_SEGMENTS.includes(segment))
  )
}
